import { createReducer } from 'redux-starter-kit';
import { handleError } from '../../modules/utils/handleError';
import i18next from 'i18next';
import { VoucherAppointmentsApi } from './VoucherAppointmentsApi';
import * as Dict from '../../modules/utils/Dict';
import Notice from '../../modules/utils/Notice';

/**
 * Constants
 */

export const voucherAppointmentsModule = 'voucherAppointments';
const SET_DATA = `${voucherAppointmentsModule}/SET_DATA`;
const LOADING = `${voucherAppointmentsModule}/LOADING`;
const CLEAR_STATE = `${voucherAppointmentsModule}/CLEAR_STATE`;

/**
 * Reducer
 */

const initialState = {
  loading: true,
  data: [],
  pageNumber: 1,
  totalElements: 0
};

export default createReducer(initialState, {
  [SET_DATA]: (state, action) => {
    state.data = action.data;
    state.pageNumber = action.pageNumber;
    state.totalElements =
      action.pageNumber === 1 ? action.totalElements : state.totalElements;
  },
  [LOADING]: (state, action) => {
    state.loading = action.loading;
  },
  [CLEAR_STATE]: () => initialState
});

export const clearState = () => ({ type: CLEAR_STATE });

export const loadAppointments = filter => async dispatch => {
  try {
    const { data } = await VoucherAppointmentsApi.getAppointments(JSON.stringify(filter));
    for (let row of data.result.content) {
      row.providerLocation = await Dict.item('60', row.queuedRegion);
    }
    if (data.status === 'SUCCESS') {
      const content = [];
      for (let item of data.result.content) {
        let queuedType = item.queuedType
          ? await Dict.item('gu_queued_type', item.queuedType || '')
          : '';
        let appStatusWeb = item.appStatusWeb
          ? await Dict.item('voucher_status_web', item.appStatusWeb || '')
          : '';
        let priorityQueued = item.priorityQueued
          ? await Dict.item('priority_queued', item.priorityQueued || '')
          : '';
        let priorityCategory = item.priorityCategory
          ? await Dict.item('priority_category', item.priorityCategory || '')
          : '';

        content.push({
          ...item,
          queuedTypeStatus: queuedType,
          appStatusWebStatus: appStatusWeb,
          priorityQueuedStatus: priorityQueued,
          priorityCategory: priorityCategory
        });
      }
      dispatch({
        type: SET_DATA,
        data: content,
        pageNumber: data.result.pageNumber,
        totalElements: data.result.totalElements
      });
    } else {
      Notice.error(i18next.t('voucher_appointments_errorLoad'));
    }
  } catch (error) {
    handleError(error, i18next.t('voucher_appointments_errorLoad'));
  } finally {
    dispatch({ type: LOADING, loading: false });
  }
};
export const prolongVoucher = (id, modal, filter) => async dispatch => {
  try {
    dispatch({ type: LOADING, loading: true });

    await VoucherAppointmentsApi.prolongVoucher({
      id: id
    });
    dispatch(loadAppointments(filter));
    modal.close();
  } catch (error) {
    handleError(error, i18next.t('voucher_applications_error_prolongVoucher'));
  } finally {
    dispatch({ type: LOADING, loading: false });
  }
};
export const appointmentDownload = ({ requestFormId }) => async dispatch => {
  try {
    dispatch({ type: LOADING, loading: true });
    const response = await VoucherAppointmentsApi.appointmentDownload(requestFormId);
    download(
      response.data,
      `${i18next.t('voucher_appointments_subtitleDownload')}-${requestFormId}.pdf`
    );
  } catch (error) {
    handleError(error, i18next.t('voucher_applications_errorLoad'));
  } finally {
    dispatch({ type: LOADING, loading: false });
  }
};

const download = (data, fileName) => {
  let element = document.createElement('a');
  document.body.appendChild(element);
  element.style.display = 'none';
  let blob = new Blob([data]);
  let url = window.URL.createObjectURL(blob);
  element.href = url;
  element.download = fileName;
  element.click();
  window.URL.revokeObjectURL(url);
};
